import { BACKEND_API_URL } from '../../../api/Backend_API_URL';
export class AxiosStreamersGateway {
    constructor(axiosBackendInstance) {
        this.axiosBackendInstance = axiosBackendInstance;
    }
    retrieveAllStreamers() {
        return this.axiosBackendInstance.axiosInstance.get(`${BACKEND_API_URL.STREAMERS}`)
            .then(response => {
            console.log('retrieveAllStreamers', response.data);
            return response.data;
        })
            .catch(error => Promise.reject(error));
    }
    hasStreamerRegistered(username) {
        return this.axiosBackendInstance.axiosInstance.get(`${BACKEND_API_URL.STREAMERS}/${username}`)
            .then(response => {
            console.log('hasStreamerRegistered', !!response.data, response.data);
            return !!response.data;
        })
            .catch(error => Promise.reject(error));
    }
    registerStreamer(streamer) {
        return this.axiosBackendInstance.axiosInstance.post(BACKEND_API_URL.STREAMERS, streamer)
            .then(response => Promise.resolve(response.data))
            .catch(error => Promise.reject(error));
    }
}
